import createIcon from '../../createIcon';

/**
 * @component @name SignalCellularNodata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTNIMTNWMjJIMkwyMiAyVjEzWk0yMSAxNS40MUwxOS41OSAxNEwxNy41IDE2LjA5TDE1LjQxIDE0TDE0IDE1LjQxTDE2LjA5IDE3LjVMMTQgMTkuNTlMMTUuNDEgMjFMMTcuNSAxOC45MkwxOS41OSAyMUwyMSAxOS41OUwxOC45MiAxNy41TDIxIDE1LjQxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellularNodata = createIcon('SignalCellularNodata', [
  [
    'path',
    {
      d: 'M22 13H13V22H2L22 2V13ZM21 15.41L19.59 14L17.5 16.09L15.41 14L14 15.41L16.09 17.5L14 19.59L15.41 21L17.5 18.92L19.59 21L21 19.59L18.92 17.5L21 15.41Z',
      key: '1s9nuu',
    },
  ],
]);

export default SignalCellularNodata;
